import { Progress } from 'antd';
import React from 'react';
import type { RppPrizeCoupon } from '../../stores/rpp-prize-coupon';
import style from './style.module.scss';

interface InventoryProgressProps {
    coupon: RppPrizeCoupon;
}

function clamp(value: number, minimum: number, maximum: number): number {
    return Math.min(Math.max(value, minimum), maximum);
}

function formatQuantity(value: number): string {
    return value.toLocaleString();
}

export const InventoryProgress = ({ coupon }: InventoryProgressProps) => {
    if (coupon.type === 'in_store' || !coupon.quantity) {
        return <span>—</span>;
    }

    const total = coupon.quantity;
    const awarded = clamp(coupon.grantedQuantity, 0, total);
    const hasActivationData = coupon.activatedQuantity != null;
    const activated = hasActivationData
        ? clamp(coupon.activatedQuantity ?? 0, 0, awarded)
        : 0;
    const awardedPercent = (awarded / total) * 100;
    const activatedPercent = (activated / total) * 100;
    const progressLabel = hasActivationData
        ? `${formatQuantity(awarded)} of ${formatQuantity(
              total
          )} awarded; ${formatQuantity(activated)} activated`
        : `${formatQuantity(awarded)} of ${formatQuantity(
              total
          )} awarded; activation count unavailable`;

    return (
        <div className={style.inventory_progress}>
            <div className={style.inventory_metrics}>
                <span>
                    <strong>{formatQuantity(total)}</strong> Quantity
                </span>
                <span className={style.awarded_metric}>
                    <strong>{formatQuantity(awarded)}</strong> Awarded
                </span>
                <span className={style.activated_metric}>
                    <strong>
                        {hasActivationData ? formatQuantity(activated) : '—'}
                    </strong>{' '}
                    Activated
                </span>
            </div>
            <Progress
                aria-label={progressLabel}
                percent={awardedPercent}
                success={
                    hasActivationData
                        ? {
                              percent: activatedPercent,
                              strokeColor: 'var(--UNKNOWN-Ant-Green)',
                          }
                        : undefined
                }
                showInfo={false}
                strokeColor="var(--UNKNOWN-Ant-Orange)"
                trailColor="var(--UNKNOWN-Gray-e0e0e0)"
                strokeWidth={8}
            />
        </div>
    );
};
